var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShopbagGradient = function SvgShopbagGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_12970_257806)",
    d: "M17.646 22H6.348C3.954 22 2 20.073 2 17.713v-.14L2.433 6.14C2.507 3.787 4.46 2 6.78 2h10.433c2.32 0 4.273 1.787 4.348 4.14l.432 11.427c.075 1.14-.365 2.213-1.156 3.073A4.14 4.14 0 0 1 17.794 22h-.148M6.78 3.427c-1.595 0-2.826 1.213-2.9 2.713l-.433 11.573c0 1.574 1.305 2.86 2.9 2.86h11.448c.797 0 1.52-.36 2.028-.926a3.08 3.08 0 0 0 .798-2.074l-.433-11.426c-.074-1.574-1.305-2.714-2.9-2.714H6.78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_12970_257806)",
    fillRule: "evenodd",
    d: "m1.8 17.566.434-11.433C2.312 3.667 4.36 1.8 6.78 1.8h10.433c2.421 0 4.469 1.866 4.547 4.333l.433 11.423c.077 1.202-.387 2.326-1.209 3.22a4.34 4.34 0 0 1-3.19 1.424H6.348c-2.501 0-4.547-2.014-4.547-4.487zm20.194 0L21.561 6.14C21.487 3.786 19.533 2 17.214 2H6.78c-2.32 0-4.273 1.786-4.347 4.14L2 17.573v.14C2 20.073 3.955 22 6.348 22h11.447c1.156 0 2.252-.5 3.043-1.36.79-.86 1.23-1.934 1.156-3.073M6.581 3.434c-1.497.096-2.63 1.27-2.7 2.707l-.433 11.573c0 1.573 1.305 2.86 2.9 2.86h11.447c.798 0 1.521-.36 2.029-.927a3.08 3.08 0 0 0 .797-2.073L20.19 6.146c-.075-1.573-1.305-2.713-2.9-2.713H6.78v-.007a3 3 0 0 0-.2.007m.003.2C5.192 3.728 4.147 4.818 4.08 6.15l-.432 11.568c.002 1.458 1.214 2.656 2.7 2.656h11.447c.736 0 1.407-.332 1.88-.86.474-.53.746-1.202.747-1.936l-.433-11.421c-.07-1.462-1.208-2.523-2.7-2.523z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_12970_257806)",
    d: "M12 10.573c-2.826 0-5.07-2.213-5.07-5 0-.426.29-.713.723-.713s.724.287.724.713c0 2 1.595 3.574 3.624 3.574s3.624-1.574 3.624-3.574c0-.426.29-.713.723-.713s.724.287.724.713c0 2.787-2.245 5-5.071 5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_12970_257806)",
    fillRule: "evenodd",
    d: "M12 10.774c-2.935 0-5.271-2.3-5.271-5.2 0-.26.09-.492.259-.66a.93.93 0 0 1 .664-.254c.261 0 .495.088.664.254.17.168.26.4.26.66 0 1.886 1.503 3.373 3.423 3.373s3.425-1.487 3.425-3.374c0-.26.09-.491.259-.659a.93.93 0 0 1 .664-.254c.261 0 .495.088.665.254.169.168.258.4.258.66 0 2.9-2.336 5.2-5.27 5.2m-5.071-5.2c0 2.786 2.244 5 5.07 5s5.071-2.214 5.071-5c0-.427-.29-.714-.723-.714s-.723.287-.723.713c0 2-1.596 3.574-3.625 3.574S8.375 7.573 8.375 5.573c0-.426-.29-.713-.723-.713s-.723.287-.723.713",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12970_257806",
    x1: 12.001,
    x2: 12.001,
    y1: 2,
    y2: 21.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12970_257806",
    x1: 12.002,
    x2: 12.002,
    y1: 1.8,
    y2: 22.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12970_257806",
    x1: 12.001,
    x2: 12.001,
    y1: 4.86,
    y2: 10.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12970_257806",
    x1: 11.999,
    x2: 11.999,
    y1: 4.66,
    y2: 10.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3C78"
  })))));
};
export default SvgShopbagGradient;